<template>
  <div class="simple-table">
    <el-table
      ref="table"
      v-show="!noData"
      :stripe="stripe"
      :data="tableData"
      force-scroll
      style="width: 100%;"
    >
      <el-table-column
        v-for="item in tableHead"
        :key="item.id"
        show-overflow-tooltip
        :width="item.width"
        :prop="item.key"
        :label="item.title"
      >
      </el-table-column>
    </el-table>
    <no-data v-show="noData"></no-data>
  </div>
</template>

<script>
/*
   * 列表组件
   * 参数
   * stripe 是否有斑马纹
   * widgetId 请求table组件数据id
   * */
import noData from './no-data'
import api from 'api/api'
export default {
  name: 'simple-table',
  props: {
    widgetId: {
      type: String,
      default: ''
    },
    stripe: {
      type: Boolean,
      default: false
    },
    refreshPeriod: {
      // 部件刷新周期
      type: Number,
      default: 0
    }
  },
  components: {
    noData
  },
  data () {
    return {
      tableHead: [],
      tableData: [],
      noData: false
    }
  },
  created () {
    this._getData()
    this.loopRefreshWidget()
  },
  methods: {
    // 轮巡请求
    loopRefreshWidget () {
      if (this.refreshPeriod !== 0) {
        setInterval(() => {
          this._getData()
        }, this.refreshPeriod * 1000)
      }
    },
    _getData () {
      api.widget
        .getData(this.widgetId)
        .then(data => {
          this.noData = false
          this.tableHead = data.data.columns || []
          this.tableData = data.data.list || []
        })
        .catch(() => {
          this.noData = true
        })
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/var.less";
@import "~assets/styles/mixin.less";
.simple-table {
  width: 100%;
  height: 100%;
}
</style>
